global.AppConfig = {
HOST : 'https://ttip.chinafilm-hualong.com/testplatform'
}
